import React from 'react';
import {prepareUrl} from 'app/utilities/StringHelpers/StringHelpers';

const NavButtonsList = ({props, buttons, index, setTabsUrlList}) => {

  const {
    headerData: {tabIndex, navButtonsCurrent, showTabItems, arrowIndex, tabs},
    context,
    isBusinessNavigation,isBusinessNavigationMode, setNavItemIndex, toggleTabButton
  } = props;

  const isBusinessMode = isBusinessNavigation || isBusinessNavigationMode || tabs[tabIndex]?.isBusinessTab?.value === true;

  return (
    <div
      className={`nav-item-list-wrapper ${showTabItems && arrowIndex === index && (isBusinessMode) ? 'business' : ''}`}>
      {buttons?.map((val, i) => (
        <React.Fragment key={i}>
          <div className="wrapper-tab">
            {val.links?.expandedValue.map((v, ind) => (
              <div
                key={ind}
                onClick={() => {
                  setNavItemIndex(index)
                  let subTabUrl = v?.link?.value;
                  setTabsUrlList((currentList) => {
                    return {[subTabUrl]: index + navButtonsCurrent?.length, ...currentList};
                  });
                  toggleTabButton(index);
                  prepareUrl(subTabUrl, context);
                }}
                className={`nav-item-list-single-item ${buttons?.length === 1 ? 'single-tab' : ''}`}>
                <span className={`${isBusinessMode ? (v.textColor?.value === 0 ? 'purple-business' : 'white') : (v.textColor?.value === 0 ? 'purple' : 'black')} text-color`}>
                  {v.text?.value}
                </span>
              </div>
            ))}
          </div>
          {i === 0 && buttons?.length > 1 && <div className="tab-seperator"></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default NavButtonsList;
